import React from 'react';
import { CTAButton } from './CTAButton';
import { StarIcon } from 'lucide-react';
export const StickyCTA = ({
  showNewImage = false
}) => {
  return <div className="sticky-cta" data-id="element-338">
      <div className="sticky-cta-inner" data-id="element-339">
        <h3 className="text-xl font-bold text-center mb-3 text-gray-900" data-id="element-340">
          Give Your Child's Brain the Fuel It Needs!
        </h3>
        <div className="product-image mb-4 bg-gray-100 rounded-lg overflow-hidden" data-id="element-341">
          <div className="aspect-w-1 aspect-h-1 relative w-full" style={{
          paddingBottom: '100%'
        }} data-id="element-342">
            <div className="absolute inset-0 flex flex-col items-center justify-center p-4" data-id="element-343">
              <img src="https://cdn.magicpatterns.com/uploads/9ERgot9Jr7hN7fpZiVThhz/ChatGPT_Image_10_Ιαν_2026,_06_18_07_μ.μ..png" alt="Nymera Kids Focus Drops with packaging and fresh berries" className="object-contain h-full w-full" data-id="element-344" />
            </div>
          </div>
        </div>
        <div className="customer-reviews mb-4" data-id="element-345">
          <div className="flex items-center justify-center mb-1" data-id="element-346">
            <div className="flex" data-id="element-347">
              {[1, 2, 3, 4, 5].map((star, index) => <StarIcon key={index} className={`h-5 w-5 ${index < 5 ? 'text-yellow-400' : 'text-gray-300'} fill-current`} data-id="element-348" />)}
            </div>
            <span className="ml-2 text-sm font-semibold" data-id="element-349">4.9 out of 5</span>
          </div>
          <p className="text-center text-sm text-gray-600" data-id="element-350">
            2,847 parent ratings
          </p>
        </div>
        <div className="ratings-breakdown mb-4 px-2" data-id="element-351">
          {[{
          label: '5★',
          percentage: 92
        }, {
          label: '4★',
          percentage: 6
        }, {
          label: '3★',
          percentage: 1
        }, {
          label: '2★',
          percentage: 0
        }, {
          label: '1★',
          percentage: 1
        }].map((rating, index) => <div key={index} className="flex items-center text-sm mb-1" data-id="element-352">
              <span className="w-8" data-id="element-353">{rating.label}</span>
              <div className="flex-1 mx-2 bg-gray-200 rounded-full h-2.5" data-id="element-354">
                <div className="bg-yellow-400 h-2.5 rounded-full" style={{
              width: `${rating.percentage}%`
            }} data-id="element-355"></div>
              </div>
              <span className="w-8 text-right" data-id="element-356">{rating.percentage}%</span>
            </div>)}
        </div>
        <a href="https://trynymera.com/products/nymera-kids-focus-drops" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all w-full uppercase tracking-wider text-center mb-2 block" data-id="element-357">
          CHECK AVAILABILITY →
        </a>
        <p className="text-xs text-center text-gray-500" data-id="element-358">
          Limited time offer - Fast FREE shipping across the US
        </p>
      </div>
    </div>;
};